var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 48,
    viewBox: "0 0 43 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.7081 1.65137H7.47053C4.20269 1.65137 1.55359 4.76662 1.55359 8.60947V39.4639C1.55359 43.3068 4.20269 46.422 7.47053 46.422H33.7081C36.976 46.422 39.6251 43.3068 39.6251 39.4639V8.60947C39.6251 4.76662 36.976 1.65137 33.7081 1.65137Z",
    stroke: "#19292C",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5891 16.3235V18.2542",
    stroke: "#19292C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5892 31.7506V29.8292",
    stroke: "#19292C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4562 20.9496C23.3689 19.4433 22.3141 18.2494 21.0133 18.2494H20.0099C18.7369 18.2494 17.7058 19.4619 17.7058 20.9589C17.7058 22.1995 18.4236 23.2814 19.4468 23.5846L21.7271 24.4893C22.7503 24.7924 23.4681 25.8744 23.4681 27.1149C23.4681 28.6119 22.437 29.8245 21.164 29.8245H20.1606C18.8559 29.8245 17.801 28.6259 17.7177 27.1196",
    stroke: "#19292C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.97742 24.0369C8.97742 16.4958 14.1766 10.3818 20.5892 10.3818C27.0019 10.3818 32.2011 16.4958 32.2011 24.0369C32.2011 31.5779 27.0019 37.6919 20.5892 37.6919C15.9334 37.6919 11.9161 34.4694 10.068 29.8151",
    stroke: "#19292C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.43289f21685b818547167938b9a72daf.svg";
export { ForwardRef as ReactComponent };